import { API_BASE_URL } from "./apiService";

const BASE = `${API_BASE_URL}/api/location`;

const headers = { "Content-Type": "application/json" };
const opts = { credentials: "include" as RequestCredentials };

export const locationApi = {
  getAll: async () => {
    const res = await fetch(BASE, opts);
    if (!res.ok) throw new Error("Failed to fetch locations");
    return res.json();
  },

  create: async (data: any) => {
    const res = await fetch(BASE, {
      ...opts,
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error("Failed to create location");
    return res.json();
  },

  update: async (id: string, data: any) => {
    const res = await fetch(`${BASE}/${id}`, {
      ...opts,
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error("Failed to update location");
    return res.json();
  },

  remove: async (id: string) => {
    const res = await fetch(`${BASE}/${id}`, {
      ...opts,
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to delete location");
    return res.json();
  },
};
